(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("myAccountResource", ["$resource", myAccountResource]);
    function myAccountResource($resource) {
        return $resource("/api/account/:action/:actionValue", { action: "@action", actionValue: "@actionValue" }, {
            getModificationNotes: {
                method: "GET",
                params: { action: "modificationNotes" },
                isArray: true
            },
            isPasswordValid: {
                method: "GET",
                params: { action: "isPasswordValid" }
            },
            getProfilePicture: {
                method: "GET",
                params: {
                    action: "profilePicture"
                }
            },
            cropProfilePicture: {
                method: "POST",
                params: {
                    action: "profilePicture",
                    actionValue: "crop"
                }
            },
            removeProfilePicture: {
                method: "POST",
                params: {
                    action: "profilePicture",
                    actionValue: "remove"
                }
            },
            updateMyAccountInformation: {
                method: "POST",
                params: {
                    action: "updateMyAccountInformation"
                }
            },
            updateMyPersonalInformation: {
                method: "POST",
                params: {
                    action: "updateMyPersonalInformation"
                }
            },
            updateMyAddressInformation: {
                method: "POST",
                params: {
                    action: "updateMyAddressInformation"
                }
            },
            getMissingRequiredRegistrationFieldsViewModel: {
                method: "GET",
                params: {
                    action: "missingRequiredRegistrationFieldsViewModel"
                }
            },
            updateMissingRequiredRegistrationFields: {
                method: "POST",
                params: {
                    action: "updateMissingRequiredRegistrationFields"
                }
            },
            updateMyPreferences: {
                method: "POST",
                params: {
                    action: "updateMyPreferences"
                }
            },
            isUserMissingRequiredRegistrationFields: {
                method: "GET",
                params: { action: "isUserMissingRequiredRegistrationFields" }
            },
            getMyPointsHistory: {
                method: "GET",
                params: { action: "pointsHistory" }
            },
            getMyPointsDashboard: {
                method: "GET",
                params: { action: "pointsDashboard" }
            },
            getMyTierDashboard: {
                method: "GET",
                params: { action: "tierDashboard" }
            },
            getPointsLeaderboards: {
                method: "GET",
                params: { action: "pointsLeaderboards" }
            },
            getMyBadges: {
                method: "GET",
                params: { action: "badges" }
            },
            getMyBadgesSummary: {
                method: "GET",
                params: { action: "badgesSummary" }
            },
            getBadgeDetails: {
                method: "POST",
                params: { action: "badgeDetails" }
            },
            getAccountCertificatesViewModel: {
                method: "GET",
                params: { action: "certificates" }
            },
            downloadBadge: {
                method: "POST",
                params: { action: "downloadBadge" }
            },
            deleteBadge: {
                method: "POST",
                params: { action: "deleteBadge" }
            },
            shareViaEmail: {
                method: "POST",
                params: { action: "shareViaEmail" }
            },
            getDisqus: {
                method: "GET",
                params: { action: "disqus" }
            }
        });
    }
}());
